import {
    Chart, Coordinate, Axis, Tooltip, Interaction, Interval, Guide, View, Coord, Geom
} from 'bizcharts';
import { Text } from 'bizcharts/lib/g-components';
import numeral from 'numeral';
import React, { useEffect, useState } from 'react'
import { Accordion, Dropdown, Form, Icon, Menu, Segment } from 'semantic-ui-react';
import { InicioMobileAsync, ObtenerLibrosAsync } from '../Servicios/ServiciosPublicos';
import DataSet from "@antv/data-set";
import { RowRender } from '../Controles/RowRender';
import { PrincipalMobile } from './PrincipalMobile';
import { useDispatch } from 'react-redux';
import { MostrarPopup } from '../Reducers/PopupReducer';
import { MonedaDetalleRender } from './MonedaDetalle';
import { ShowBusy } from '../Reducers/InicioReducer';

export const PrincipalDesktopInicio = () => {
    //#region hooks
    const dispatch = useDispatch();
    //#endregion
    //#region internalState
    const [internalState, setInternalState] = useState({
        Load: false,
        Libros: [],
        BalanceG: [],
        InicioMobile: {
            Saldo: 0,
            Detalle: []
        },
        ActiveIndex: 0,
        CongifIndex: 0,
    })
    //#endregion
    //#region useEffect
    useEffect(() => {
        Load();
        const _objInt = setInterval(() => { ObtenerInicioMobile(); }, 5000);
        return () => { console.log("kill interval"); if (_objInt) { clearInterval(_objInt); } };
    }, [])
    //#endregion
    //#region Metodos
    const Load = async () => {
        ObtenerInicioMobile(true);
    }
    const ObtenerInicioMobile = async (showBusy = false) => {
        let _w = +window.innerWidth;
        if (_w > 767) {
            if (showBusy) { dispatch(ShowBusy()); }
            let inicio = await InicioMobileAsync();
            dispatch(ShowBusy(false));
            setInternalState((state) => { return { ...state, InicioMobile: inicio, Load: true } });
        }
    }
    const OnClickItem = async (item) => {
        dispatch(MostrarPopup({
            Titulo: `${item.Nombre}`,
            Content: <MonedaDetalleRender MonedaDetalle={{ Item: item, Detalle: [] }} />,
            TieneBotonCerrar: true,
            Height: "400px",
            Cerrar: (r) => { }
        }))
    }
    //#endregion

    return (
        <div className="principal-desktop-columns">
            <div className="principal-mobile-detalle" style={{ minWidth: "300px" }}>
                {internalState.InicioMobile.Detalle.map((item, i) => (<RowRender index={i} Item={item} onClick={OnClickItem} />))}
            </div>
            <div style={{ minWidth: "500px", width: "70%", position: "relative", height: "500px" }}>
                {+internalState.InicioMobile.Saldo > 0 && (<div className="saldo-render">{numeral(internalState.InicioMobile.Saldo).format("0,000.00")}</div>)}
                <Chart data={internalState.InicioMobile.Detalle} height={500} autoFit >
                    <Coordinate type="theta" radius={0.8} innerRadius={0.75} />
                    <Axis visible={false} />
                    <Tooltip showTitle={false} />
                    <Interval
                        adjust="stack"
                        position="TotalMXN"
                        color="Nombre"
                        shape="sliceShape"
                    />
                    <Interaction type="element-single-selected" />

                </Chart>

            </div>
        </div>
    )
}
